import { formatUnits } from 'viem';

export const formatToken = (amount, decimals) => {
  return amount && decimals && formatUnits(BigInt(amount.toString()), decimals); // eslint-disable-line no-undef
};

export const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
